import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './common/SafeIcon';
import './App.css';

const { FiSmartphone, FiGlobe } = FiIcons;

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-6">
      <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 max-w-md w-full text-center">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-12">
          Alimos Telematics
        </h1>
        
        <div className="flex flex-col items-center space-y-4">
          <a
            href="https://play.google.com/store/apps/details?id=com.waveloc.appsAndroid614a178bdddae"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-transform duration-200 hover:scale-105"
          >
            <img 
              src="https://h3.waveloc.com/Google_Play_Store_badge_EN.svg" 
              alt="Get it on Google Play" 
              className="h-20"
            />
          </a>
          
          <a
            href="https://apps.apple.com/us/app/alimos-telematics/id6451309892"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-transform duration-200 hover:scale-105"
          >
            <img 
              src="https://h3.waveloc.com/Download_on_the_App_Store_Badge.svg" 
              alt="Download on the App Store" 
              className="h-20"
            />
          </a>
                    <a
            href="https://timetables.waveloc.com/alimostelematics"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-transform duration-200 hover:scale-105"
          >
            <img 
              src="https://h3.waveloc.com/Load_on_Web_badge.svg" 
              alt="Load from Web" 
              className="h-20"
            />
          </a>
    
        </div>
      </div>
    </div>
  );
}

export default App;